import { useQuery } from '@tanstack/react-query';

import { getNew } from '../api/ventura/lineItem';
import mapLineItemToForm from '../util/mapLineItemToForm';
import { useConfig } from './useConfig';

function useNewLineItem(contractId: number) {
  const { apiHost } = useConfig();

  const query = useQuery({
    queryKey: ['lineItem', contractId],
    queryFn: () => getNew(apiHost, contractId),
    select: (data) => mapLineItemToForm(data),
  });

  return query;
}

export default useNewLineItem;
